import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

// The one interceptor, for /api requests: the client header 0054 requires on writes, and
// a session gone (expired, revoked, deactivated) handled in one place
export const apiInterceptor: HttpInterceptorFn = (request, next) => {
  if (!request.url.startsWith('/api/')) {
    return next(request);
  }

  const router = inject(Router);

  return next(request.clone({ setHeaders: { 'X-Prodsee-Client': 'prodsee-app' } })).pipe(
    catchError((error: unknown) => {
      // 401 from the auth calls themselves is an answer, not a lost session: the session store reads it
      if (error instanceof HttpErrorResponse && error.status === 401 && !request.url.startsWith('/api/auth/')) {
        // A reload, not a navigation: nothing of this session may survive in the page stores
        document.location.assign(`/sign-in?returnUrl=${encodeURIComponent(router.url)}`);
      }

      return throwError(() => error);
    })
  );
};
